export enum IssuePriority {
  //remove Low here when we sure that it is no more in DB
  Low = 0,
  Normal = 10,
  High = 20,
}

// @see https://zypone.atlassian.net/browse/SL-1307
// Will copy/paste here important information in case this link gets outdated.
// Until now, we used to refer to 3 main kinds of issues: ad-hoc, in-form and automatic.
// From now on, we will also have a new kind. An action (issue) that is created from a submission
// (so it relates to the whole submission, and not to a specific query). This can happen automatically
// after a form is submitted (defined in the Template builder) or manually (from the report or the submissions
// (done inspections) table view). For this not to be confusing, let’s have new terminology for all the action
// (issue) kinds:
// 1. Manual item action (formerly in-form issue)
//    Also includes the issues raised manually from negative responses
// 2. Automatic item action (formerly automatic issue)
// 3. Manual form action (new)
// 4. Automatic form action (new)
// 5. Ad-hoc action
// 6. Sensor action
export enum IssueType {
  Automatic = 'automatic',
  InForm = 'in_form',
  Sensor = 'sensor_alarm',
  AdHoc = 'ad_hoc',
  ManualForm = 'manual_inspection',
  AutomaticForm = 'automatic_inspection',
}
